export default {
	"SeckillComponent.HotRush": "Hot rush",
	"SeckillComponent.ComingSoon": "Coming soon",
	"SeckillComponent.OnlyTheEndIsLeft": "Only the end is left",
	"SeckillComponent.LimitedTimeSpikes": "Limited time spikes",
	"SeckillComponent.sky": "sky"
}